import React from 'react';
import { Button } from '@/components/ui/button';
import { Plane, Cloud, Compass, Globe, Wind, Zap } from 'lucide-react';

const LOGO_OPTIONS = [
  { id: 1, icon: Plane, label: 'Aircraft' },
  { id: 2, icon: Cloud, label: 'Cloud' },
  { id: 3, icon: Compass, label: 'Compass' },
  { id: 4, icon: Globe, label: 'Globe' },
  { id: 5, icon: Wind, label: 'Wind' },
  { id: 6, icon: Zap, label: 'Lightning' },
];

export default function StepLogo({ form, setForm, next, back }) {
  const canProceed = form.logoId !== null;

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-3xl font-light mb-2" style={{ color: 'var(--text-primary)' }}>
          Select Logo
        </h1>
        <p className="text-sm font-light" style={{ color: 'var(--text-secondary)' }}>
          Choose a symbol to represent your airline.
        </p>
      </div>

      <div className="grid grid-cols-3 gap-4">
        {LOGO_OPTIONS.map((logo) => {
          const Icon = logo.icon;
          const isSelected = form.logoId === logo.id;
          return (
            <button
              key={logo.id}
              onClick={() => setForm({ ...form, logoId: logo.id })}
              className="p-8 rounded-sm transition-all"
              style={{
                borderWidth: '1px',
                borderColor: isSelected ? 'var(--neon)' : 'var(--border)',
                backgroundColor: isSelected ? 'var(--neon-dim)' : 'var(--bg-panel)',
              }}
            >
              <Icon 
                className="w-12 h-12 mx-auto mb-2" 
                style={{ color: isSelected ? 'var(--neon)' : 'var(--text-secondary)', strokeWidth: 1 }}
              />
              <div className="text-xs font-light" style={{ color: isSelected ? 'var(--neon)' : 'var(--text-secondary)' }}>
                {logo.label}
              </div>
            </button>
          );
        })}
      </div>

      <div className="flex justify-between pt-4" style={{ borderTopWidth: '1px', borderColor: 'var(--border)' }}>
        <Button
          onClick={back}
          variant="outline"
          className="font-normal px-8 rounded-sm"
          style={{ borderColor: 'var(--border)', color: 'var(--text-primary)' }}
        >
          Back
        </Button>
        <Button
          onClick={next}
          disabled={!canProceed}
          className="font-normal px-8 rounded-sm"
          style={{ backgroundColor: 'var(--neon)', color: '#000' }}
        >
          Continue
        </Button>
      </div>
    </div>
  );
}